import { render, staticRenderFns } from "./FilterSummaryItemShinTapir.vue?vue&type=template&id=1a357216&"
import script from "./FilterSummaryItemShinTapir.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItemShinTapir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports